import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getFirestoreGlobalVariablesThunk } from './action';
import { SupportedLangsType } from '../../shared/enums/supportedLangs.enum';
import { FirebaseDate } from '../../pages/types';

export type GlobalVariables = {
  minimumPeriodForCancellationSeconds: number;
  minimumPeriodForRescheduleSeconds: number;
  currentWebVersionUserApp: string;
  euroToUahRate: string;
  specialistReviewsCountForShowing: number;
  numberOfWeeksForScheduleRendering: number;
  defaultOnBoardingId: { [key: string]: string };
  minimumFetchIntervalForRemoteConfigInSeconds: number;
  clientDoBModalShowCount: number;
  terms_of_conditions: Record<SupportedLangsType | 'en', string>;
  features?: {
    session_reviews?: {
      start_date?: FirebaseDate;
    };
  };
};

export const firestoreGlobalVariables = createSlice({
  name: 'firestoreGlobalVariables',
  initialState: {} as GlobalVariables,
  reducers: {
    setGlobalVariables: (state, action: PayloadAction<GlobalVariables>) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFirestoreGlobalVariablesThunk.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

export default firestoreGlobalVariables.reducer;
export const { setGlobalVariables } = firestoreGlobalVariables.actions;
